<div id="layout" class="theme-cyan">
  <app-project-leftmenu></app-project-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body: -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container-fluid">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Invoices</h5>
                  </div>
                  <small class="text-truncate text-muted">Total 15 (last update 1hr ago)</small>
                </div>
              </div>
            </div>

            <!-- page action  -->
            <div class="col-7 col-xl-8 text-end">
              <ul class="nav justify-content-end d-inline-flex">
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <a href="javascript:void(0)" class="nav-link text-muted px-3" (click)="isCollapsed = !isCollapsed"
                    [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic" title="Search this chat">
                    <i class="zmdi zmdi-search zmdi-hc-lg"></i>
                  </a>
                </li>
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <a class="nav-link text-muted" [routerLink]="['/app-project-invoice-create']"
                    href="javascript:void(0)">Add invoice</a>
                </li>
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <button class="btn btn-sm btn-dark" type="button">Export Report</button>
                </li>

                <!-- Mobile nav -->
                <li class="nav-item list-inline-item d-block d-sm-none px-3">
                  <div class="dropdown">
                    <a class="nav-link text-muted px-0" href="javascript:void(0)" data-bs-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false">
                      <i class="zmdi zmdi-more-vert zmdi-hc-lg"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <a class="dropdown-item" href="app-project-invoice-create.html">Add invoice</a>
                      <a class="dropdown-item" href="javascript:void(0)">Generate Report</a>
                      <a class="dropdown-item" href="javascript:void(0)">Export Report</a>
                    </div>
                  </div>
                </li>
                <!-- Mobile nav -->
              </ul>
            </div>

          </div>

        </div>
      </div>


      <!-- Body: Search -->
      <div class="collapse" id="collapseBasic" [collapse]="isCollapsed" [isAnimated]="true">
        <div class="container-fluid py-2">

          <div class="row">
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Search...">
              <div class="input-group-append">
                <span class="input-group-text text-muted"><small>0 / 0</small></span>
              </div>
              <div class="input-group-append dropdown" dropdown placement="bottom right">
                <button type="button" class="btn btn-secondary">Search</button>


                <button id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                  class="btn btn-secondary dropdown-toggle dropdown-toggle-split ml-1">
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                  aria-labelledby="button-basic">
                  <a href="javascript:void(0);" class="dropdown-item">Action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                  <div role="separator" class="dropdown-divider"></div>
                  <a class="dropdown-item" href="javascript:void(0)">Separated link</a>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container-fluid">

          <div class="row">
            <div class="col-12">
              <div class="card mb-3">
                <div class="table-responsive">
                  <table class="table table-hover vertical-center mb-0">
                    <thead>
                      <tr>
                        <th class="border-top-0">Client Id</th>
                        <th class="border-top-0">Client details</th>
                        <th class="border-top-0">Date</th>
                        <th class="border-top-0">Amount</th>
                        <th class="border-top-0">Status</th>
                        <th class="border-top-0">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <span>A5210</span>
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <img src="../assets/images/xs/avatar1.jpg" data-bs-toggle="tooltip" title="Avatar Name"
                              alt="Avatar" class="rounded-circle avatar">
                            <div class="ms-3">
                              <a href="javascript:void(0)" [routerLink]="['/app-project-invoice-detail']" title="">South
                                Shyanne</a>
                              <p class="mb-0">south.shyanne@example.com</p>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div><span class="text-muted">Invoice Date:</span> 12 Aug 2020</div>
                          <div><span class="text-muted">Due Date:</span> 22 Aug 2020</div>
                        </td>
                        <td>$1200</td>
                        <td><span class="badge bg-success ml-0 mr-0">Done</span></td>
                        <td>
                          <button type="button" class="btn btn-sm btn-default" title="Send Invoice"><i
                              class="zmdi zmdi-email"></i></button>
                          <button type="button" class="btn btn-sm btn-default ml-1" title="Print"><i
                              class="zmdi zmdi-print"></i></button>
                          <button type="button" class="btn btn-sm btn-default ml-1" title="Delete"><i
                              class="zmdi zmdi-delete"></i></button>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span>A5254</span>
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <img src="../assets/images/xs/avatar2.jpg" data-bs-toggle="tooltip" title="Avatar Name"
                              alt="Avatar" class="rounded-circle avatar">
                            <div class="ms-3">
                              <a href="javascript:void(0)" [routerLink]="['/app-project-invoice-detail']" title="">Zoe
                                Baker</a>
                              <p class="mb-0">zoe.baker@example.com</p>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div><span class="text-muted">Invoice Date:</span> 15 Aug 2020</div>
                          <div><span class="text-muted">Due Date:</span> 22 Aug 2020</div>
                        </td>
                        <td>$378</td>
                        <td><span class="badge bg-success ml-0 mr-0">Done</span></td>
                        <td>
                          <button type="button" class="btn btn-sm btn-default" title="Send Invoice"><i
                              class="zmdi zmdi-email"></i></button>
                          <button type="button" class="btn btn-sm btn-default ml-1" title="Print"><i
                              class="zmdi zmdi-print"></i></button>
                          <button type="button" class="btn btn-sm btn-default ml-1" title="Delete"><i
                              class="zmdi zmdi-delete"></i></button>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span>A5214</span>
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <img src="../assets/images/xs/avatar3.jpg" data-bs-toggle="tooltip" title="Avatar Name"
                              alt="Avatar" class="rounded-circle avatar">
                            <div class="ms-3">
                              <a href="javascript:void(0)" [routerLink]="['/app-project-invoice-detail']" title="">Colin
                                Brown</a>
                              <p class="mb-0">colinbrown@example.com</p>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div><span class="text-muted">Invoice Date:</span> 12 Aug 2020</div>
                          <div><span class="text-muted">Due Date:</span> 22 Aug 2020</div>
                        </td>
                        <td>$653</td>
                        <td><span class="badge bg-success ml-0 mr-0">Done</span></td>
                        <td>
                          <button type="button" class="btn btn-sm btn-default" title="Send Invoice"><i
                              class="zmdi zmdi-email"></i></button>
                          <button type="button" class="btn btn-sm btn-default ml-1" title="Print"><i
                              class="zmdi zmdi-print"></i></button>
                          <button type="button" class="btn btn-sm btn-default ml-1" title="Delete"><i
                              class="zmdi zmdi-delete"></i></button>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span>A5217</span>
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <img src="../assets/images/xs/avatar4.jpg" data-bs-toggle="tooltip" title="Avatar Name"
                              alt="Avatar" class="rounded-circle avatar">
                            <div class="ms-3">
                              <a href="javascript:void(0)" [routerLink]="['/app-project-invoice-detail']" title="">Kevin
                                Gill</a>
                              <p class="mb-0">kevin.gill@example.com</p>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div><span class="text-muted">Invoice Date:</span> 13 Aug 2020</div>
                          <div><span class="text-muted">Due Date:</span> 26 Aug 2020</div>
                        </td>
                        <td>$451</td>
                        <td><span class="badge bg-warning  ml-0 mr-0">Panding</span></td>
                        <td>
                          <button type="button" class="btn btn-sm btn-default" title="Send Invoice"><i
                              class="zmdi zmdi-email"></i></button>
                          <button type="button" class="btn btn-sm btn-default ml-1" title="Print"><i
                              class="zmdi zmdi-print"></i></button>
                          <button type="button" class="btn btn-sm btn-default ml-1" title="Delete"><i
                              class="zmdi zmdi-delete"></i></button>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span>A5273</span>
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <img src="../assets/images/xs/avatar5.jpg" data-bs-toggle="tooltip" title="Avatar Name"
                              alt="Avatar" class="rounded-circle avatar">
                            <div class="ms-3">
                              <a href="javascript:void(0)" [routerLink]="['/app-project-invoice-detail']" title="">Maria
                                Gill</a>
                              <p class="mb-0">Maria.gill@example.com</p>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div><span class="text-muted">Invoice Date:</span> 10 Aug 2020</div>
                          <div><span class="text-muted">Due Date:</span> 18 Aug 2020</div>
                        </td>
                        <td>$1,989</td>
                        <td><span class="badge bg-success  ml-0 mr-0">Done</span></td>
                        <td>
                          <button type="button" class="btn btn-sm btn-default" title="Send Invoice"><i
                              class="zmdi zmdi-email"></i></button>
                          <button type="button" class="btn btn-sm btn-default ml-1" title="Print"><i
                              class="zmdi zmdi-print"></i></button>
                          <button type="button" class="btn btn-sm btn-default ml-1" title="Delete"><i
                              class="zmdi zmdi-delete"></i></button>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span>A5244</span>
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <img src="../assets/images/xs/avatar6.jpg" data-bs-toggle="tooltip" title="Avatar Name"
                              alt="Avatar" class="rounded-circle avatar">
                            <div class="ms-3">
                              <a href="javascript:void(0)" [routerLink]="['/app-project-invoice-detail']" title="">Kevin
                                Baker</a>
                              <p class="mb-0">kevin.baker@example.com</p>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div><span class="text-muted">Invoice Date:</span> 22 Aug 2020</div>
                          <div><span class="text-muted">Due Date:</span> 23 Aug 2020</div>
                        </td>
                        <td>$343</td>
                        <td><span class="badge bg-warning  ml-0 mr-0">Panding</span></td>
                        <td>
                          <button type="button" class="btn btn-sm btn-default" title="Send Invoice"><i
                              class="zmdi zmdi-email"></i></button>
                          <button type="button" class="btn btn-sm btn-default ml-1" title="Print"><i
                              class="zmdi zmdi-print"></i></button>
                          <button type="button" class="btn btn-sm btn-default ml-1" title="Delete"><i
                              class="zmdi zmdi-delete"></i></button>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span>A5277</span>
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <img src="../assets/images/xs/avatar3.jpg" data-bs-toggle="tooltip" title="Avatar Name"
                              alt="Avatar" class="rounded-circle avatar">
                            <div class="ms-3">
                              <a href="app-project-invoice-detail.html" title="">Colin Brown</a>
                              <p class="mb-0">colin-brown@example.com</p>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div><span class="text-muted">Invoice Date:</span> 12 Aug 2020</div>
                          <div><span class="text-muted">Due Date:</span> 22 Aug 2020</div>
                        </td>
                        <td>$653</td>
                        <td><span class="badge bg-success ml-0 mr-0">Done</span></td>
                        <td>
                          <button type="button" class="btn btn-sm btn-default" title="Send Invoice"><i
                              class="zmdi zmdi-email"></i></button>
                          <button type="button" class="btn btn-sm btn-default ml-1" title="Print"><i
                              class="zmdi zmdi-print"></i></button>
                          <button type="button" class="btn btn-sm btn-default ml-1" title="Delete"><i
                              class="zmdi zmdi-delete"></i></button>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span>A5288</span>
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <img src="../assets/images/xs/avatar4.jpg" data-bs-toggle="tooltip" title="Avatar Name"
                              alt="Avatar" class="rounded-circle avatar">
                            <div class="ms-3">
                              <a href="javascript:void(0)" [routerLink]="['/app-project-invoice-detail']" title="">Kevin
                                Gill</a>
                              <p class="mb-0">kevin-gill@example.com</p>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div><span class="text-muted">Invoice Date:</span> 7 Aug 2020</div>
                          <div><span class="text-muted">Due Date:</span> 12 Aug 2020</div>
                        </td>
                        <td>$451</td>
                        <td><span class="badge bg-warning  ml-0 mr-0">Panding</span></td>
                        <td>
                          <button type="button" class="btn btn-sm btn-default" title="Send Invoice"><i
                              class="zmdi zmdi-email"></i></button>
                          <button type="button" class="btn btn-sm btn-default ml-1" title="Print"><i
                              class="zmdi zmdi-print"></i></button>
                          <button type="button" class="btn btn-sm btn-default ml-1" title="Delete"><i
                              class="zmdi zmdi-delete"></i></button>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span>A5273</span>
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <img src="../assets/images/xs/avatar5.jpg" data-bs-toggle="tooltip" title="Avatar Name"
                              alt="Avatar" class="rounded-circle avatar">
                            <div class="ms-3">
                              <a href="javascript:void(0)" [routerLink]="['/app-project-invoice-detail']" title="">Maria
                                Gill</a>
                              <p class="mb-0">Maria.gill@example.com</p>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div><span class="text-muted">Invoice Date:</span> 12 Aug 2020</div>
                          <div><span class="text-muted">Due Date:</span> 22 Aug 2020</div>
                        </td>
                        <td>$1,989</td>
                        <td><span class="badge bg-success  ml-0 mr-0">Done</span></td>
                        <td>
                          <button type="button" class="btn btn-sm btn-default" title="Send Invoice"><i
                              class="zmdi zmdi-email"></i></button>
                          <button type="button" class="btn btn-sm btn-default ml-1" title="Print"><i
                              class="zmdi zmdi-print"></i></button>
                          <button type="button" class="btn btn-sm btn-default ml-1" title="Delete"><i
                              class="zmdi zmdi-delete"></i></button>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span>A5244</span>
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <img src="../assets/images/xs/avatar6.jpg" data-bs-toggle="tooltip" title="Avatar Name"
                              alt="Avatar" class="rounded-circle avatar">
                            <div class="ms-3">
                              <a href="javascript:void(0)" [routerLink]="['/app-project-invoice-detail']" title="">Kevin
                                Baker</a>
                              <p class="mb-0">kevin.baker@example.com</p>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div><span class="text-muted">Invoice Date:</span> 15 Aug 2020</div>
                          <div><span class="text-muted">Due Date:</span> 20 Aug 2020</div>
                        </td>
                        <td>$343</td>
                        <td><span class="badge bg-warning  ml-0 mr-0">Panding</span></td>
                        <td>
                          <button type="button" class="btn btn-sm btn-default" title="Send Invoice"><i
                              class="zmdi zmdi-email"></i></button>
                          <button type="button" class="btn btn-sm btn-default ml-1" title="Print"><i
                              class="zmdi zmdi-print"></i></button>
                          <button type="button" class="btn btn-sm btn-default ml-1" title="Delete"><i
                              class="zmdi zmdi-delete"></i></button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <nav>
                <ul class="pagination pagination-custom">
                  <li class="page-item"><a class="page-link" href="javascript:void(0)">Previous</a></li>
                  <li class="page-item active"><a class="page-link" href="javascript:void(0)">1</a></li>
                  <li class="page-item"><a class="page-link" href="javascript:void(0)">2</a></li>
                  <li class="page-item"><a class="page-link" href="javascript:void(0)">3</a></li>
                  <li class="page-item"><a class="page-link" href="javascript:void(0)">Next</a></li>
                </ul>
              </nav>
            </div>
          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
